import { authFetch } from './fetchWithAuth'

export interface PendingApprovalItem {
  Id: number
  StudiAnrede: string | null
  StudiVorname: string | null
  StudiNachname: string | null
  StudiMatrikel: string | null
  StudiStudienort: string | null
  ZuzahlerFirma: string | null
  ZuzahlerApName: string | null
  ZuzahlerApEmail: string | null
  Status: string
  AdminApprovalRequestedAt: string | null
  CreatedAt: string
}

export interface PendingApprovalsResponse {
  items: PendingApprovalItem[]
  total: number
}

export async function listPendingApprovals(firmaId: number): Promise<PendingApprovalsResponse> {
  const r = await authFetch(`/api/firma/${firmaId}/zuzahler-approvals`)
  if (!r.ok) throw new Error(`Liste laden fehlgeschlagen: ${r.status}`)
  return r.json()
}

export async function confirmApproval(firmaId: number, id: number): Promise<void> {
  const r = await authFetch(`/api/firma/${firmaId}/zuzahler-approvals/${id}/confirm`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Bestaetigen fehlgeschlagen: ${r.status}`)
}

export async function takeoverApproval(firmaId: number, id: number): Promise<void> {
  const r = await authFetch(`/api/firma/${firmaId}/zuzahler-approvals/${id}/takeover`, {
    method: 'POST',
  })
  if (!r.ok) throw new Error(`Uebernehmen fehlgeschlagen: ${r.status}`)
}

export async function rejectApproval(
  firmaId: number,
  id: number,
  reason: string,
): Promise<void> {
  const r = await authFetch(`/api/firma/${firmaId}/zuzahler-approvals/${id}/reject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ Reason: reason }),
  })
  if (!r.ok) throw new Error(`Ablehnen fehlgeschlagen: ${r.status}`)
}
